"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _DateFormatter = _interopRequireDefault(require("../../modules/DateFormatter"));

var _Legend = _interopRequireDefault(require("../../components/Legend"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ToolPanel = function ToolPanel(_ref) {
  var userType = _ref.userType;
  var summary = (0, _reactRedux.useSelector)(function (state) {
    return state.summaryReducer.summary;
  });
  var visible = (0, _reactRedux.useSelector)(function (state) {
    return state.menuReducer.currentMenu === 'TOOLS';
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'ToolPanel',
    style: {
      display: visible ? 'block' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-legend'
  }, /*#__PURE__*/_react.default.createElement(_Legend.default, {
    userType: userType
  })), summary && /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-summary'
  }, summary === null || summary === void 0 ? void 0 : summary.update_wording['EN-US'], ":\xA0 ", (summary === null || summary === void 0 ? void 0 : summary.update_wording) && /*#__PURE__*/_react.default.createElement(_DateFormatter.default, null, summary === null || summary === void 0 ? void 0 : summary.date_generated)));
};

ToolPanel.propTypes = {
  userType: _propTypes.default.any.isRequired
};
var _default = ToolPanel;
exports.default = _default;